import { render, staticRenderFns } from "./Articles.vue?vue&type=template&id=62bd11ce&scoped=true&"
import script from "./Articles.vue?vue&type=script&lang=js&"
export * from "./Articles.vue?vue&type=script&lang=js&"
import style0 from "./Articles.vue?vue&type=style&index=0&id=62bd11ce&prod&lang=css&"
import style1 from "./Articles.vue?vue&type=style&index=1&id=62bd11ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bd11ce",
  null
  
)

export default component.exports